import {createAction, props} from '@ngrx/store';
import {AssignmentDto, CreateAssignmentDto, UpdateAssignmentDto} from '@shared/dto';

// Read list
export const readAssignments = createAction('@app/assignment/read', props<{ memberId?: number; deleted?: boolean }>());
export const readAssignmentsSuccess = createAction('@app/assignment/read/success', props<{ data: AssignmentDto[] }>());
export const readAssignmentsFailure = createAction('@app/assignment/read/failure', props<{ error: any }>());

// Create
export const createAssignment = createAction('@app/assignment/create', props<{ memberId: number; dto: CreateAssignmentDto }>());
export const createAssignmentSuccess = createAction('@app/assignment/create/success', props<{ assignment: AssignmentDto }>());
export const createAssignmentFailure = createAction('@app/assignment/create/failure', props<{ error: any }>());

// Update
export const updateAssignment = createAction('@app/assignment/update', props<{ memberId: number; assignmentId: number; dto: UpdateAssignmentDto }>());
export const updateAssignmentSuccess = createAction('@app/assignment/update/success', props<{ assignment: Partial<AssignmentDto> }>());
export const updateAssignmentFailure = createAction('@app/assignment/update/failure', props<{ error: any }>());

// Delete — `confirm` resends as `?confirm=true` after the 428 (started therapy) is accepted.
export const deleteAssignment = createAction(
  '@app/assignment/delete',
  props<{ memberId: number; assignmentId: number; confirm?: boolean }>(),
);
export const deleteAssignmentSuccess = createAction('@app/assignment/delete/success', props<{ assignment: AssignmentDto }>());
export const deleteAssignmentFailure = createAction('@app/assignment/delete/failure', props<{ error: any }>());
// 428: the therapy has already started. Soft-delete is allowed but deliberate — the page
// confirms with the backend message and resends `confirm`.
export const deleteAssignmentRequiresConfirmation = createAction(
  '@app/assignment/delete/requires-confirmation',
  props<{ memberId: number; assignmentId: number; message: string }>(),
);

// Restore
export const restoreAssignment = createAction('@app/assignment/restore', props<{ memberId: number; assignmentId: number }>());
export const restoreAssignmentSuccess = createAction('@app/assignment/restore/success', props<{ assignment: AssignmentDto }>());
export const restoreAssignmentFailure = createAction('@app/assignment/restore/failure', props<{ error: any }>());
